import * as yup from 'yup'
import * as IbanKit from 'ibankit'
import i18n from '../../i18n'
import { isEmpty } from 'lodash'
import { ACCOUNT_NUM_VALIDATION_MSG, ACCOUNT_NUMBER_REGEXP } from '../../constants/validations'
import { optionalBicCountries } from '../../stubs'
import { AccountIdTypeEnum } from '../../types'

export const SwiftInputSchema = yup.object().shape({
  swift: yup
    .string()
    .test('swiftIsRequired', i18n.t('thisFieldIsRequired', 'This field is required'), function () {
      if (!this.parent.destinationBankCountry) {
        return !isEmpty(this.parent.swift)
      }

      const activeTab = !!this.parent.accountNumber
      if (optionalBicCountries.includes(this.parent.destinationBankCountry) && activeTab) {
        return true
      }

      return !isEmpty(this.parent.swift)
    })
    .test(
      'swiftIsCorrect',
      i18n.t('incorrectSwiftFormat', 'Incorrect SWIFT/BIC format'),
      function (value) {
        if (!this.parent.destinationBankCountry || value) {
          return IbanKit.BIC.isValid(value || '')
        }

        const activeTab = !!this.parent.accountNumber
        if (optionalBicCountries.includes(this.parent.destinationBankCountry) && activeTab) {
          return true
        }

        return IbanKit.BIC.isValid(value || '')
      },
    )
    .test(
      'correctCountry',
      i18n.t('incorrectDestinationCountry', 'Destination Bank Country does not match Swift/BIC'),
      function () {
        if (!this.parent.destinationBankCountry) {
          return true
        }

        const activeTab = !!this.parent.accountNumber
        if (
          optionalBicCountries.includes(this.parent.destinationBankCountry) &&
          activeTab &&
          !this.parent.swift
        ) {
          return true
        }

        return (
          !isEmpty(this.parent.swift) &&
          this.parent.destinationBankCountry === this.parent.swift.substring(4, 6)?.toLowerCase()
        )
      },
    ),
  accountNumber: yup
    .string()
    .test(
      'accountRecipientIsRequired',
      i18n.t('thisFieldIsRequired', 'This field is required'),
      function (value) {
        const activeTab = this.parent.accountIdType

        return activeTab === AccountIdTypeEnum.iban || !isEmpty(value)
      },
    )
    .matches(ACCOUNT_NUMBER_REGEXP, {
      message: ACCOUNT_NUM_VALIDATION_MSG,
      excludeEmptyString: true,
    }),
  destinationBankCountry: yup.string(),
})

export type SwiftInput = yup.Asserts<typeof SwiftInputSchema>
